import * as React from "react";
import { renderEventIcons } from "./renderEventIcons";
import { renderMarketsCount } from "./renderMarketsCount";
export const renderIconsWrapper = (event, componentPrefix, dict, handlers, isDesktop) => React.createElement("div", { className: `rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__icons-holder`, "data-uat": `div-ev-list-${componentPrefix}-icons-holder` },
    renderEventIcons(event, dict, isDesktop, handlers, componentPrefix),
    !isDesktop && renderMarketsCount(componentPrefix, event.marketLinesCount));
//# sourceMappingURL=renderIconsWrapper.js.map